import {recomTag} from '../model';

const setMetaTags = ({
                         title = recomTag.title,
                         description = recomTag.description,
                         imageUrl = recomTag.imageUrl,
                         url = ''
                     }) => {
    const titleObj = document.querySelector('meta[property="og:title"]');
    if (titleObj) titleObj.setAttribute('content', title);
    const desp = document.querySelector('meta[property="og:description"]');
    if (desp) desp.setAttribute('content', description);
    const img = document.querySelector('meta[property="og:image"]');
    if (img) img.setAttribute('content', imageUrl);
    const urlObj = document.querySelector('meta[property="og:url"]');
    if(url!=='') {
        if (urlObj) urlObj.setAttribute('content', url);
    }else{
        if (urlObj) urlObj.setAttribute('content', window.location.href);
    }

    /*document
        .querySelector('meta[property="og:description"]')
        .setAttribute("content", description);
    document
        .querySelector('meta[property="og:image"]')
        .setAttribute("content", imageUrl);
    document
        .querySelector('meta[property="og:url"]')
        .setAttribute("content", window.location.href);*/

};

export default setMetaTags;
